<ng-container *notInPopulation="[populations.Pts]">
  <div class="full-page-container">
    <fgb-banner [title]="'partner.page.title' | translate"></fgb-banner>

    <div class="d-block d-lg-none">
      <fgb-page-header
        [pageTitle]="'account.page.title'"
        [backButtonLink]="'/'"
        [showQr]="!isSuiteOrPts"
        [showBalance]="!isSuiteOrPts"
      ></fgb-page-header>
    </div>

    <fgb-account-nav></fgb-account-nav>

    <div *ngIf="partnerLimit$ | async as partnerLimit" class="container">
      <ng-container *notInPopulation="[populations.Partner]">
        <div class="mb-lg-4 mt-2 mt-lg-0">
          <ng-container *notInPopulation="[populations.Free]">
            <h5 class="title-partner">{{ 'partner.title' | translate }}</h5>
            <ng-container *inPopulation="[populations.Default]">
              <p
                class="font-size-14 partner-description"
                [innerHTML]="'partner.page.info.text.default' | translate | markdownTranslate"
              ></p>
            </ng-container>
            <ng-container *inPopulation="[populations.Suite]">
              <p
                class="font-size-14 partner-description"
                [innerHTML]="'partner.page.info.text' | translate | markdownTranslate"
              ></p>
            </ng-container>
          </ng-container>
          <ng-container *inPopulation="[populations.Free]">
            <h5 class="title-partner">{{ 'partner.free.title' | translate }}</h5>
            <p
              class="font-size-14 partner-description"
              [innerHTML]="'partner.page.free.info.text' | translate | markdownTranslate"
            ></p>
          </ng-container>
          <div class="add-member-button d-flex align-items-center flex-lg-row">
            <ng-container *inPopulation="populations.Free">
              <button
                *ifScreenSize="screenType.Desktop"
                class="partner-button border-0 text-center text-white bg-success pt-0 d-flex align-items-center justify-content-center me-lg-4 mb-3 mb-lg-0"
                (click)="openAcceptForm()"
                aria-label="Add new partner"
                [ngClass]="{
                  'greyed-out': currentPartnerCount >= 1,
                }"
              >
                <span class="material-icons"> add_task </span>
                <label class="cursor-pointer mb-0 text-capitalize">{{ 'button.accept.partner' | translate }}</label>
              </button>
              <button
                *ifScreenSize="screenType.Mobile"
                class="mb-partner-button border-0 text-center text-white bg-success pt-0 d-flex align-items-center justify-content-center"
                [ngClass]="{
                  'greyed-out': currentPartnerCount >= 1,
                }"
                (click)="openAcceptForm()"
                aria-label="Add new partner"
              >
                <span class="material-icons"> add_task </span>
                <label class="cursor-pointer mb-0">{{ 'button.accept.partner' | translate }}</label>
              </button>
            </ng-container>
            <ng-container *notInPopulation="populations.Free">
              <button
                *ifScreenSize="screenType.Desktop"
                class="partner-button border-0 text-center text-white bg-primary pt-0 d-flex align-items-center justify-content-center"
                (click)="openAddForm()"
                aria-label="Add new partner"
                [ngClass]="{
                  active: !showAcceptForm,
                  'not-active': showAcceptForm,
                  'greyed-out': currentPartnerCount >= partnerLimit,
                }"
              >
                <span class="material-icons"> person_add_alt_1 </span>
                <label class="cursor-pointer mb-0">{{ 'add.new.partner.button' | translate }}</label>
              </button>
              <button
                *ifScreenSize="screenType.Mobile"
                class="mb-partner-button border-0 text-center text-white bg-primary pt-0 d-flex align-items-center justify-content-center"
                (click)="openAddForm()"
                aria-label="Add new partner"
                [ngClass]="{
                  active: !showAcceptForm,
                  'not-active': showAcceptForm,
                  'greyed-out': currentPartnerCount >= partnerLimit,
                }"
              >
                <span class="material-icons me-2"> person_add_alt_1 </span>
                <label class="cursor-pointer mb-0">{{
                  'add.new.partner.button' | translate: { fgbdefault: 'Add New Partner' }
                }}</label>
              </button>
            </ng-container>
          </div>
          <ng-container *ngIf="showAddForm || showAcceptForm">
            <hr class="m-2" />
            <div class="card-body">
              <fgb-partner-add-form (close)="openAddForm()" *ngIf="showAddForm"></fgb-partner-add-form>
              <fgb-partner-accept-form (close)="openAcceptForm()" *ngIf="showAcceptForm"></fgb-partner-accept-form>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="currentPartnerCount > 0; else partnerPlaceholder">
        <div class="partner-list-container">
          <fgb-partner-list></fgb-partner-list>
        </div>
      </ng-container>
      <ng-template #partnerPlaceholder>
        <h5 class="title-partner" *inPopulation="[populations.Default]">
          {{ 'no.partner.placeholder.title' | translate }}
        </h5>
        <h5 class="title-partner" *notInPopulation="[populations.Default]">
          {{ 'partner.list.partner.title' | translate }}
        </h5>
        <div class="card border card-primary my-2 bg-white font-size-14">
          <div class="card-body partner-list-placeholder-container">
            <div class="d-flex flex-row text-start details-header mx-0">
              <div class="col-10 col-lg-3 d-lg-none d-block">
                <label class="fw-bold">{{ 'partner.details' | translate }}</label>
              </div>
              <div class="col-4 d-lg-block d-none ps-0">
                <label class="fw-bold">{{ 'partner.fullname' | translate }}</label>
              </div>
              <div class="col-5 d-lg-block d-none">
                <label class="fw-bold">{{ 'partner.email' | translate }}</label>
              </div>
              <div class="col-2 d-lg-block d-none ps-0">
                <label class="fw-bold">{{ 'partner.status' | translate }}</label>
              </div>
              <div class="col-2 col-lg-1 d-block">
                <label class="fw-bold">{{ 'partner.action' | translate }}</label>
              </div>
            </div>
            <ng-container *ifScreenSize="screenType.Desktop">
              <div class="text-center font-size-14 mt-3 font-sans">
                {{ 'no.partner.placeholder.description' | translate }}
              </div>
            </ng-container>
            <ng-container *ifScreenSize="screenType.Mobile">
              <div class="text-center font-size-14 mt-3 font-sans">
                {{ 'no.partner.placeholder.description.mobile' | translate }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
